// Impostazioni Cache dell'App Web
const cacheConfig =  {
    capacityInBytes: 4000000,
    itemMaxSize: 400000,
    defaultTTL: 36000000
  }

export default cacheConfig